module.exports = __webpack_public_path__ + "static/media/ContasPagRec9.90718173.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec9.png
// module id = 2019
// module chunks = 0